import { render, staticRenderFns } from "./BillTotals.vue?vue&type=template&id=3743234b"
import script from "./BillTotals.vue?vue&type=script&lang=js"
export * from "./BillTotals.vue?vue&type=script&lang=js"
import style0 from "./BillTotals.vue?vue&type=style&index=0&id=3743234b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports